/*api
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { UpiPaymentMst  } from '../../../interfaces/masters/UpiPaymentMst';

@Injectable()
export class UpiPaymentApi {
  private readonly apiController: string = 'upipayment';
  private branchId = localStorage.getItem("branchId");
  constructor(private api: HttpService) { }

  list(options?: any): Observable<any[]> {

     const branchList = JSON.parse(localStorage.getItem('branchAccessList') || '[]');
  const countryId = branchList.find(x => x.id === this.branchId)?.country || null;
    const headers = new HttpHeaders({
    'Accept': 'application/vnd.ezovion.hateoas+json',
    'Content-Type': 'application/json'
  });
    const params = new HttpParams().set('countryId', countryId);
    return this.api.get(this.apiController, { headers, params });
  }

  getById(url : string, options?: any): Observable<UpiPaymentMst> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }

  add(url:string, data: UpiPaymentMst):Observable<UpiPaymentMst[]>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPost( url, data, header);
  }

  update(url:string, data: UpiPaymentMst):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    // const formData: FormData = new FormData();
    // formData.append('Image', data.photo);
    // data.photo = formData;
    return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }
}
